module.exports = __webpack_public_path__ + "img/PRINT.7b192577.svg";